import { FC } from "react";

import { useSearchParams } from "next/navigation";

import { trpc } from "@/common/helpers/trpc";
import { ContainerLoader } from "@/components/Loaders/ContainerLoader";
import { DonationLiveFormEditor } from "@/features/LiveFormEditor/DonationLiveFormEditor";

export const DonationLiveFormEditorContainer: FC = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const { donationFormId } = query;

  const { data: apiDonationForm, isFetching } = trpc.getDonationFormWithUserOrOrgAccess.useQuery(
    { donationFormId: donationFormId as string },
    {
      enabled: !!donationFormId,
      refetchOnMount: "always",
    }
  );

  if (!donationFormId || isFetching || !apiDonationForm) {
    return <ContainerLoader />;
  }

  return <DonationLiveFormEditor apiDonationForm={apiDonationForm} />;
};
